import { createSlice } from '@reduxjs/toolkit'

//const TAG = '[clicksSlice]';

interface ClicksState {
    clicks: number;
    id: number;
    name: string;
}

export const clicksSlice = createSlice({
  name: 'clicks',
  initialState: {
    value: [] as ClicksState[],
  },
  reducers: {
    handleClick: (state, action) => {
       // let tmpArrayValue = [...state.value];
      const result = state.value.find((item) => item.id === action.payload.id && item.name === action.payload.name);
      if(result){
        //console.log(`${TAG} found record ${action.payload.name} - id ${action.payload.id}`);
        result.clicks = result.clicks + 1;
      }else {
        //console.log(`${TAG} not found record ${action.payload.name} - id ${action.payload.id}`);
        state.value.push({
          clicks: 1,
          id: action.payload.id,
          name: action.payload.name,
        });
      }
    },
    clearClicks: (state) => {
      state.value = [];
    },
  },
})

// Action creators are generated for each case reducer function
export const { handleClick,clearClicks} = clicksSlice.actions

export default clicksSlice.reducer